import { $dfs } from '@lexical/utils';
import _ from 'lodash';
import { $setEditorStateFromHtmlString } from 'modules/Lexical/Plugins/HtmlContentPlugin';
import * as Models from 'models';
import { createLexicalTextEditor } from '../../editors';
import { $createReferenceCitationNode } from '../../nodes/ReferenceCitationNode';
import { REFERENCE_CITATION_MARKER } from '../nodes/ReferenceCitationNodeWithExportDom';

const $processReferenceCitations = (
  referenceCitationIds: string[],
  getActualReferenceCitationId: (referenceId: string) => string,
): string[] => {
  const actualReferenceCitationIds: string[] = [];

  const referenceCitationIdsLength = referenceCitationIds.length;
  let referenceCitationIdsIndex = 0;
  const nodesArray = $dfs();
  nodesArray.forEach((dfsNode) => {
    const textContent = dfsNode.node.getTextContent();
    if (textContent.trim() === REFERENCE_CITATION_MARKER) {
      const referenceCitationId = referenceCitationIdsIndex < referenceCitationIdsLength ?
        referenceCitationIds[referenceCitationIdsIndex]
        : '';
      const actualReferenceCitationId = getActualReferenceCitationId(referenceCitationId);

      if (actualReferenceCitationId) {
        actualReferenceCitationIds.push(actualReferenceCitationId);
        dfsNode.node.replace($createReferenceCitationNode(actualReferenceCitationId));
      }

      referenceCitationIdsIndex++;
    }
  });

  return actualReferenceCitationIds;
};

export const restoreLexicalStateAndReferencesFromText = (
  textComponent: Models.TextComponent,
  getActualReferenceCitationId: (referenceId: string) => string,
): Models.TextComponent => {
  const actualTextComponent = _.cloneDeep(textComponent);
  let actualReferenceCitationIds: string[] = [];

  const { text, referenceCitations: referenceCitationIds } = actualTextComponent;

  if (!text) {
    return actualTextComponent;
  }

  const editor = createLexicalTextEditor();

  editor.update(() => {
    $setEditorStateFromHtmlString(text);

    // Process Reference Citations
    if (!_.isEmpty(referenceCitationIds)) {
      actualReferenceCitationIds = $processReferenceCitations(referenceCitationIds, getActualReferenceCitationId);
    }
  }, { discrete: true });

  actualTextComponent.lexicalState = JSON.stringify(editor.getEditorState());

  if (_.isEmpty(referenceCitationIds)) {
    actualTextComponent.text = text?.replaceAll(REFERENCE_CITATION_MARKER, '');
  }

  actualTextComponent.referenceCitations = actualReferenceCitationIds;

  return actualTextComponent;
};
